import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
      form: {
          maxWidth:"100%",
          marginTop: theme.spacing(5),
          marginBottom: theme.spacing(10),
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent:'center',
          margin:"auto",

          '& h4':{
            textAlign:'center',
            [theme.breakpoints.down('xs')]:{
              fontSize:'26px',
            }
          },

          '& button': {
            marginTop:'30px'
          }
      },
      headerSection: {
          display:'grid',
          gridTemplateColumns:'repeat(1, 0.1fr 1fr 0.1fr)',
          width:'100%',
          marginTop: theme.spacing(2),
          marginBottom: theme.spacing(2),
          justifyItems:'center',
          alignItems:'center'
      },
      arrowBack:{
          width:'24px',
          height:'24px',
          textDecoration:'none',
          color: 'black'
      }
  })
);